import React, { useEffect, useMemo } from 'react';
import { Col, Form as FormB, FormCheck, FormGroup, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { filter } from '../../appStore/convocatoria';
import Form from '../../components/CompUtils/Form';
import SeccionAccordion from '../CompUtils/SeccionAccordion';
import {
  fetchJurisdiccionPublico,
  fetchTiposConcurso,
  jurisPublicoSelector,
  tiposSelector,
} from '../Concursos/Gestion/gestionConcursoSlice';

interface FiltrosInterface {
  convocatoria: string;
  jurisdiccion: string;
  niveles: string;
  cargoConReserva: boolean;
  estado?: string;
}

export const Filtros = () => {
  const dispatch = useDispatch();
  const juris = useSelector(jurisPublicoSelector);
  const tiposConvocatoria = useSelector(tiposSelector);
  const [filtros, setFiltros] = React.useState<FiltrosInterface>({
    convocatoria: '',
    jurisdiccion: '',
    niveles: '',
    cargoConReserva: false,
    estado: 'todos',
  });

  useEffect(() => {
    dispatch(fetchJurisdiccionPublico());
    dispatch(fetchTiposConcurso());
  }, [dispatch]);

  const finalTipos = useMemo(() => {
    if (!Array.isArray(tiposConvocatoria)) {
      return Object.keys(tiposConvocatoria).map((e) => ({
        id: e,
        title: tiposConvocatoria[e].nombre,
      }));
    }
    return [];
  }, [tiposConvocatoria]);

  const handleSubmit = (e?: any) => {
    if (e?.preventDefault) e.preventDefault();
    dispatch(filter(filtros));
  };

  const niveles = [{ id: 'A' }, { id: 'B' }, { id: 'C' }, { id: 'D' }, { id: 'E' }, { id: 'F' }];

  return (
    <SeccionAccordion title="Buscar convocatorias publicadas">
      <Form onSubmit={handleSubmit} submitText="Buscar" btns={['submit']}>
        <Row>
          <Col xs="4">
            <FormGroup>
              <FormB.Label>Convocatoria</FormB.Label>
              <FormB.Control
                as="select"
                id="convocatoria"
                onChange={(e: any) => {
                  setFiltros({ ...filtros, convocatoria: e.target.value });
                }}>
                {finalTipos.map((e) => (
                  <option key={e.id} value={e.id}>
                    {e.title}
                  </option>
                ))}
              </FormB.Control>
            </FormGroup>
          </Col>
          <Col xs={4}>
            <FormGroup>
              <FormB.Label>Jurisdicción</FormB.Label>
              <FormB.Control
                as="select"
                id="jurisdiccion"
                onChange={(e: any) => {
                  setFiltros({ ...filtros, jurisdiccion: e.target.value });
                }}>
                {juris?.map((e: any) => (
                  <option key={e.id} value={e.id}>
                    {e.nombre}
                  </option>
                ))}
              </FormB.Control>
            </FormGroup>
          </Col>
          <Col xs={4}>
            <FormGroup>
              <FormB.Label>Nivel</FormB.Label>
              <FormB.Control
                as="select"
                id="niveles"
                onChange={(e) => {
                  setFiltros({ ...filtros, niveles: e.target.value });
                }}>
                {niveles.map((e) => (
                  <option key={e.id} value={e.id}>
                    {e.id}
                  </option>
                ))}
              </FormB.Control>
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col xs={4}>
            <FormCheck
              label="Tiene cargo con reserva?"
              checked={filtros.cargoConReserva}
              type="checkbox"
              id="cargoConReserva"
              onChange={() => {
                setFiltros({ ...filtros, cargoConReserva: !filtros.cargoConReserva });
              }}
            />
          </Col>
          <Col xs={4}>
            <FormGroup>
              <FormB.Label>Estado de Inscripción</FormB.Label>
              <FormB.Control
                as="select"
                id="estado"
                value={filtros.estado}
                onChange={(e) => {
                  setFiltros({ ...filtros, estado: e.target.value });
                }}>
                <option value="todos">Todos</option>
                <option value="abierta">Inscripción Abierta</option>
                <option value="cerrada">Inscripción Cerrada</option>
                <option value="proxima">Próximo a abrir inscripción</option>
              </FormB.Control>
            </FormGroup>
          </Col>
        </Row>
      </Form>
    </SeccionAccordion>
  );
};
